import * as t from "io-ts";
export const orderStatusT = t.union([
    t.literal("CREATED"),
    t.literal("ACCEPTED"),
    t.literal("REJECTED"),
    t.literal("DELIVERED"),
]);
//# sourceMappingURL=order.js.map